module.exports = __webpack_public_path__ + "e2a49a303079f1d0ef576591d806b1b4.ttf";